// Test.jsx
import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
import BoardTop from './boardTop'
import Belt from './belt'
import Data from './data'
import { runhtml } from '../../tool/runtime'
import {reSetBar} from '../../tool/reSetBar'
import  RightBox from '../../components/com_all/rightBox'
// 引入action
// import { setPageTitle } from '../../store/actions.js'



class Board extends Component{
    componentDidMount(){
        reSetBar()
        this.node.scrollIntoView();
        document.title ="留言板 ~ |"
    }
    render(){
        return(
            <div ref={node => this.node = node} className="allMargintop" style={{marginBottom:0}}>
                <BoardTop loadimg={require("../../img/pixiv54839592-150x88.png")} bgimg={require("../../img/pixiv54839592.png")}/>
                
              <div style={{margin:"auto"}} className="outer row justify-content-center flex-row-reverse friendlink">
              
             <div className="rightbox">
                        <RightBox className="dark-bg"/>
                    </div>
                    <div className="leftbox">
                    <div className="dark-bg">
             <Belt/>
             
             <Data/>
             </div>
             </div>
             
             </div>
             { runhtml }
            </div>
        )
    }
}

export default connect()(Board)